import {ICaptureConfig, IGetCaptureConfigsResponse, IPostCaptureConfigResponse, IPutCaptureConfigResponse} from "interfaces";
import {axiosAPI} from "./API";
import { TaskState } from "enums";

// Singleton for interacting with CaptureConfigs
class _CaptureConfigService {

    // This gets set by App.tsx when okta reads the stored token
    public allCaptureConfigs: ICaptureConfig[] = [];
    public allCaptureConfigsMap: {[uuid: string]: ICaptureConfig} = {};

    public getAll = (): Promise<IGetCaptureConfigsResponse> => {
        
        return axiosAPI.get<IGetCaptureConfigsResponse>("/captureConfig")
            .then((resp) => {
                let captureConfigsResponse = resp.data;
                // save to cache
                this.allCaptureConfigs = captureConfigsResponse.data;
                captureConfigsResponse.data.forEach((config) => this.allCaptureConfigsMap[config.captureConfigUUID] = config);
                // filter deleted
                this.allCaptureConfigs = this.allCaptureConfigs.filter(r => r.status != TaskState.Deleted);
                // sort
                this.allCaptureConfigs.sort((a, b) => {
                    return a.name.localeCompare(b.name);
                })
                return captureConfigsResponse;
            })
            .catch((err) => {
                console.error("Error getting all capture configs: ", err);
                throw err;
            });
    }

    public postCaptureConfig = (config: Omit<ICaptureConfig, "captureConfigUUID">): Promise<IPostCaptureConfigResponse> => {

        return axiosAPI.post<IPostCaptureConfigResponse>('/captureConfig', config)
            .then((resp) => {
                let captureConfig: ICaptureConfig = {
                    captureConfigUUID: resp.data.data.captureConfigUUID,
                    ...config
                };
                // save to cache
                this.allCaptureConfigs.push(captureConfig);
                this.allCaptureConfigsMap[captureConfig.captureConfigUUID] = captureConfig;
                 // sort
                 this.allCaptureConfigs.sort((a, b) => {
                    return a.name.localeCompare(b.name);
                })
                return resp.data;
            })
            .catch((err) => {
                console.error("Error posting capture config: ", err);
                throw err;
            });
    }

    public putCaptureConfig = (uuid, config: Omit<ICaptureConfig, "captureConfigUUID">): Promise<IPutCaptureConfigResponse> => {

        let url = `/captureConfig/${uuid}`;
                
        return axiosAPI.put<IPutCaptureConfigResponse>(url, config)
            .then((resp) => {
                let captureConfig: ICaptureConfig = {
                    captureConfigUUID: resp.data.data.captureConfigUUID,
                    ...config
                };
                // update cache
                const i = this.allCaptureConfigs.findIndex(c => c.captureConfigUUID === captureConfig.captureConfigUUID);
                this.allCaptureConfigs.splice(i, 1, captureConfig);
                this.allCaptureConfigsMap[captureConfig.captureConfigUUID] = captureConfig;
                return resp.data;
            })
            .catch((err) => {
                console.error("Error putting capture config: ", err);
                throw err;
            });
    }

    public deleteCaptureConfig = (uuid: string): Promise<ICaptureConfig> => {

        let url = `/captureConfig/${uuid}`;

        return axiosAPI.delete<ICaptureConfig>(url)
            .then((resp) => {
                // remove from list
                this.allCaptureConfigs = this.allCaptureConfigs.filter(r => r.captureConfigUUID != uuid);
                // OR replace item status
                // this.allCaptureConfigs[this.allCaptureConfigs.findIndex(c => c.captureConfigUUID === uuid)].status = TaskState.Deleted;
                this.allCaptureConfigsMap[uuid].status = TaskState.Deleted;
                return resp.data;
            })
            .catch((err) => {
                console.error("Error deleting capture config: ", err);
                throw err;
            });
    }
}

export const CaptureConfigService = new _CaptureConfigService();
